// Generated from SVG to Code Figma Plugin
import React from 'react';

export const Back = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_25647_39516)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7071 3.79297L12.1213 5.20718L4.82843 12.5001L12.1213 19.793L10.7071 21.2072L2 12.5001L10.7071 3.79297Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_25647_39516">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
